import React from 'react'
import cls from 'classnames'

import classes from './GridColumn.module.scss'

export default function GridColumn(props) {
	return (
		<div
			className={cls({
				[`col-${props.size || 12}`]: true,
				[classes.GridColumn] : true,
				[classes[`GridColumn__align-${props.alignContent}`]]: !!props.alignContent,
				[props.className]: !!props.className
			})}
		>
			{props.children}
		</div>
	)
}